import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <path
      d="M20.5 5.16c-.06-.53-.5-.93-1.04-.93h-3.29v-.59c0-2.01-1.63-3.64-3.65-3.64-.38 0-.77.06-1.17.18-1.38.43-2.48 2.08-2.48 3.53v.51H4.54c-.53 0-.98.4-1.04.93l-1.75 17.7c-.07.61.41 1.15 1.03 1.15h18.43c.62 0 1.1-.54 1.04-1.15L20.5 5.16zM9.87 3.71c0-1.06.85-2.29 1.78-2.57.29-.09.58-.14.87-.14 1.46 0 2.65 1.18 2.65 2.64v.58h-5.3v-.51zM2.74 22.95L4.5 5.26c0-.02.02-.04.04-.04H7V23H2.78l-.04-.05zm18.48.05H8V5.22h11.46c.02 0 .04.02.04.03l1.76 17.69c0 .01-.04.06-.04.06z"
      fill={ fill }
      id="prefix__Layer_1"
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
